export enum ActionType {
  BUTTON = 'button',
  LINK = 'link',
  DROPDOWN = 'dropdown',
  NONE = 'none',
  SEARCH = 'search',
}
